import { Box2D } from "../../engine/physics/tbPhysics2";
import { tgfFunctions } from "../../framework/tgfFunctions";
import { getContainerForLayer, Layer, blockFactory } from "../SceneController";
import { SpineEffect } from "../SpineEffect";
import { playController } from "../gameController";
import { BirdObjectDefault } from "./BirdObject";
export function BirdObjectMatilda(def, uid, x, y, angle, container) {
    BirdObjectMatilda.uber.constructor.call(this, def, uid, x, y, angle, container);
}
tgfFunctions.inherit(BirdObjectMatilda, BirdObjectDefault);
//returns true if the power was activated
BirdObjectMatilda.prototype.activateSpecialPower = function () {
    if (this.canUsePower && !this.firstContact) {
        new SpineEffect(this.x, this.y, this.definition.smokePuff.spine, this.definition.smokePuff.name, getContainerForLayer(Layer.smokePuff), 1);
        this.playSound(this.soundStates.ABILITY, this.definition.sounds);
        // Spawn Egg
        var block = blockFactory("MatildaEgg", 10000000 + Math.floor(Math.random() * 1000000), this.x, this.y + 3, 0, playController.sceneController.levelContainer);
        playController.sceneController.levelBlocks.push(block);
        var tntVelocity = new Box2D.b2Vec2(0, 3);
        block.body.SetLinearVelocity(tntVelocity);
        // Push bird up
        var newYVelocity = this.body.GetLinearVelocity().get_y() < -1 ? this.body.GetLinearVelocity().get_y() - 1 : -2;
        var birdVelocity = new Box2D.b2Vec2(this.body.GetLinearVelocity().get_x(), newYVelocity);
        this.body.SetLinearVelocity(birdVelocity);
        this.canUsePower = false;
        return true;
    }
    return false;
};
